function Rewards() {
	return <div>Rewards</div>
}

export default Rewards
